import { outbrainMixins } from './outbrainPlacementWidgets'
import { styleMixins } from '../../common/ad_ops/styleMixins'
import type { AdPlacement } from '@duplex/common/ad_ops/adPlacementMappings'
import { taboolaMixins } from './taboolaPlacementWidgets'

export const placementConfigs: Record<string, AdPlacement> = {
  // Homepage placements
  on_newtab_r1_c2: {
    outbrain: {
      ...outbrainMixins.AR_35,
    },
    style: {
      adHeight: 304,
      adWidth: 300,
    },
    taboola: {
      ...taboolaMixins.on_newtab_r1_c2,
    },
    assertive: {},
    props: {},
  },
  on_newtab_r1_topright: {
    outbrain: {
      ...outbrainMixins.AR_36,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {
      ...taboolaMixins.on_newtab_r1_topright,
    },
    assertive: {},
    props: {},
  },
  on_newtab_r2_c1: {
    outbrain: {
      ...outbrainMixins.AR_37,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {
      ...taboolaMixins.on_newtab_r2_c1,
    },
    assertive: {},
    props: {},
  },
  on_newtab_r3_right: {
    outbrain: {
      ...outbrainMixins.AR_45,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {
      ...taboolaMixins.on_newtab_r3_right,
    },
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  on_newtab_r4_c1: {
    outbrain: {
      // TODO: @alexannmill TEMP! these are endless replace once new widgets are ready
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  on_newtab_r4_right: {
    outbrain: {
      // TODO: @alexannmill TEMP! these are endless replace once new widgets are ready
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  on_newtab_endless_native: {
    outbrain: {
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {
      ...taboolaMixins.on_newtab_endless_native,
    },
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  on_newtab_endless_right: {
    outbrain: {
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  on_newtab_slider_1: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  on_newtab_slider_2: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  on_newtab_midpage_leader: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  on_newtab_midpage_leader_repeated: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },

  // Article page placements
  on_article_hero: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins[970_90],
    },
    props: {
      sticky: true,
    },
  },
  on_article_hero_mb: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins[300_50],
    },
    props: {
      sticky: true,
    },
  },
  on_article_content_below_button: {
    outbrain: {
      ...outbrainMixins.AR_31,
    },
    taboola: {
      ...taboolaMixins.on_article_content_below_button,
    },
    assertive: {},
    style: {
      ...styleMixins.auto,
    },
    props: {},
  },
  on_article_content_middle: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins[728_90],
    },
    props: {},
  },
  on_article_content_middle_mb: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins[300_250],
    },
    props: {
      lazyRender: true,
    },
  },
  on_article_siderail_top: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  on_article_belownative_video: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  on_article_siderail_middle: {
    outbrain: {
      ...outbrainMixins.SB_2,
    },
    taboola: {
      ...taboolaMixins.on_article_siderail_middle,
    },
    assertive: {},
    style: {},
    props: {},
  },
  on_article_siderail_bottom: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  on_article_content_top: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  on_article_content_below_image: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  on_article_content_above_button: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
}
